
<template>
  <!--商品管理-->
  <div>
    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      ref="table"
      rowKey="productId"
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="true"
    >
      <template slot="opt_name" slot-scope="{row}">
        <div style="display: flex; align-items: center">
          <div style="height: 44px; margin-right: 10px">
            <img style="height: 100%" :src="row.picUrl" alt="">
          </div>
          <span>{{ row.name }}</span>
        </div>
      </template>

      <template slot="opt_status" slot-scope="{row}">
        <div style="display: flex; align-items: center">
          <span class="circle-dot" :class="statusColor[row.status] + '-bg'"></span>
          <span>{{statusObj[row.status]}}</span>
        </div>
      </template>
    </x-tabula>

    <!--的弹窗-->
    <a-modal
      title="修改分组"
      :visible="visible"
      @cancel="visible=false"
      @ok="$refs.addEdit.handleSubmit()"
      :confirmLoading="btnLoading.loading"
      v-bind="$store.state.modalConfig"
      width="650px"
    >
      <x-addEdit
        ref="addEdit"
        formType="modal"
        :isSubmitBtn="false"
        :reqLoading="btnLoading"
        :formList="formList"
        :formKey="formKey"
        :editParam="editParam"
      />
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'goodsManage',
  data () {
    const statusSelect = [
      { value: 0, label: '仓库' },
      { value: 1, label: '出售' },
      { value: 2, label: '售磬' }
    ];
    return {
      visible: false,
      btnLoading: { loading: false },
      formList: [
        {
          inputType: 'select',
          label: '分组',
          mode: 'multiple',
          placeholder: '请选择分组',
          options: [],
          props: ['groupId', {
            rules: [{required: true, message: '请选择分组'}]
          }]
        }
      ],
      formKey: { groupId: [] },
      editParam: {
        url: '/pm/product/changeGroup/',
        resHandle: this.addResHandle
      },

      statusObj: ['仓库', '出售', '售磬'], // 商品状态:0仓库, 1出售, 2售罄
      statusColor: ['info', 'success', 'danger'],
      searchList: [
        { props: ['name'], placeholder: '商品名称', options: [], inputType: 'input' },
        { props: ['groupId'], placeholder: '商品分组', options: [], inputType: 'select' },
        { props: ['status'], placeholder: '状态', options: statusSelect, inputType: 'select' },
        {
          props: ['type'],
          placeholder: '商品类型',
          options: [
            {label: '实物', value: 1},
            {label: '卡券', value: 2},
            {label: '本地优惠券', value: 4},
            {label: '微信代金券', value: 5}
          ],
          inputType: 'select'
        }
      ],
      searchParams: {
        name: undefined,
        groupId: undefined,
        status: undefined,
        type: undefined
      },
      tableOptList: [
        { text: '新增', icon: 'plus', permi: ['community:goodsManage:add'] },
        { text: '上架', handle: (ids, rows) => this.changePublishStatus(rows, 1), icon: 'upload', disabled: true, permi: ['community:goodsManage:putShelf'] },
        { text: '下架', handle: (ids, rows) => this.changePublishStatus(rows, 0), icon: 'download', disabled: true, permi: ['community:goodsManage:offShelf'] },
        { text: '删除', icon: 'close', disabled: true, permi: ['community:goodsManage:delete'] },
        { text: '修改分组', handle: this.changeGroup, icon: 'edit', disabled: true, permi: ['community:goodsManage:editGroup'] }
      ],
      rowOptList: [
        {
          text: '编辑',
          handle: row => this.$refs.table.toEdit(row),
          permi: ['community:goodsManage:edit']
        },
        {
          text: '',
          handle: row => this.changePublishStatus(row),
          customRender: true,
          rowOptText: row => row.publishStatus === 1 ? '下架' : '上架',
          rowOptDisHandle: row => row.canPublish === 0,
          permi: ['community:goodsManage:offShelf']
        },
        {
          text: '删除',
          handle: row => this.$refs.table.showDeleteConfirm(row),
          rowOptDisHandle: row => row.canDelete === 0,
          permi: ['community:goodsManage:delete']
        }
      ],
      columns: [
        { title: '商品编号', dataIndex: 'productId', align: '', width: '10' },
        { title: '商品名称', dataIndex: 'name', align: '', width: '10', scopedSlots: { customRender: 'name' } },
        { title: '商品类型', dataIndex: 'typeDesc', align: '', width: '10' },
        { title: '兑换价(积分)', dataIndex: 'point', align: '', width: '10' },
        { title: '销量', dataIndex: 'sale', align: '', width: '10' },
        { title: '库存', dataIndex: 'stock', align: '', width: '10' },
        { title: '状态', dataIndex: 'status', align: '', width: '10', scopedSlots: { customRender: 'status' } },
        { title: '操作', dataIndex: 'action', align: '', width: '10', scopedSlots: { customRender: 'action' } }
      ],
      dataSource: [],
      listApi: {
        url: '/pm/product/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addEditGoods',
        addTitle: '新增商品',
        editTitle: '编辑商品'
      },
      deleteParam: {
        url: '/pm/product/',
        title: '商品',
        key: 'name',
        resHandle: '' // 执行完删除的回调方法
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      this.$get({
        url: '/pm/group/treeSelect',
        params: {}
      }).then(({ data }) => {
        this.searchList[1].options = data;
        this.formList[0].options = data;
      });
    },
    /** 上架或下架 */
    changePublishStatus (ids, type) {
      let msg;
      let canDeletes = [];
      let isArray = Array.isArray(ids);
      type = isArray ? type : ids.publishStatus === 1 ? 0 : 1;
      if (isArray) {
        if (type === 1) {
          canDeletes = ids.filter(item => item.publishStatus === 0 && item.canPublish === 1);
          if (canDeletes.length) {
            if (canDeletes.length === ids.length) {
              msg = `确定要上架 ${canDeletes.length} 件商品？`;
            } else {
              msg = `确定要上架 ${canDeletes.length} 件商品？其中 ${ids.length - canDeletes.length} 件不可上架`;
            }
          } else {
            msg = '没有可上架的商品';
          }
        } else {
          canDeletes = ids.filter(item => item.publishStatus === 1);
          if (canDeletes.length) {
            if (canDeletes.length === ids.length) {
              msg = `确定要下架 ${canDeletes.length} 件商品？`;
            } else {
              msg = `确定要下架 ${canDeletes.length} 件商品？其中 ${ids.length - canDeletes.length} 件不可下架`;
            }
          } else {
            msg = '没有可下架的商品';
          }
        }
      } else {
        msg = type === 1 ? `确定上架商品 ${ids.name}` : `确定下架商品 ${ids.name}`;
      }

      this[isArray ? (canDeletes.length ? '$confirm' : '$error') : '$confirm']({
        title: msg,
        centered: true,
        onOk: () => {
          let canRequest;
          if (isArray) {
            canDeletes.length ? canRequest = true : canRequest = false;
          } else {
            canRequest = true;
          }
          canRequest && this.submitPublishStatus(isArray ? canDeletes : ids, type);
        }
      });
    },
    submitPublishStatus (ids, type) {
      const productIds = Array.isArray(ids) ? ids.map(item => item.productId).join(',') : ids.productId;
      this.$put({
        url: `/pm/product/changeStatus/${productIds}`,
        params: { publishStatus: type }
      }).then((res) => {
        this.$message.success(res.msg);
        this.$refs.table.getTableList();
      });
    },
    /** 修改分组 */
    changeGroup (ids) {
      this.getSelect();
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.addEdit.routeQuery = ids.join(',');
      });
    },
    /** 修改分组回调函数 */
    addResHandle () {
      this.visible = false;
      this.$refs.table.getTableList();
    },
    /** 编辑商品 */
    toEdit (row) {
      this.$router.push({
        name: 'addEditGoods',
        query: { id: row.productId, ...this.breadParam(this) }
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
